const themeCountries = [
    {name: "영어", parser : "st_theme_en" },
    {name: "스페인어", parser : "st_theme_es" },
    {name: "프랑스어", parser : "st_theme_fr" },
    {name: "독일어", parser : "st_theme_de" },
    {name: "이탈리아어", parser : "st_theme_it" },
    {name: "네덜란드어", parser : "st_theme_nl" },
    {name: "폴란드어", parser : "st_theme_pl" },
    {name: "포르투갈어", parser : "st_theme_pt" },
    {name: "스웨던어", parser : "st_theme_sv" },
    {name: "러시아어", parser : "st_theme_ru" },
    {name: "한국어", parser : "st_theme_ko" },
    {name: "중국어-간체", parser : "st_theme_zhs" },
    {name: "중국어-번체", parser : "st_theme_zht" },
    {name: "일본어", parser : "st_theme_ja" },
    {name: "아랍어", parser : "st_theme_ar" },
    {name: "인도네시아어", parser : "st_theme_id" },
    {name: "베트남어", parser : "st_theme_vi" },
    {name: "태국어", parser : "st_theme_th" },
    {name: "힌디어", parser : "st_theme_hi" },
    {name: "뱅골어", parser : "st_theme_bn" },
]
export {themeCountries};

